import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=95dbd626&scoped=true"
import script from "./Paragraph.vue?vue&type=script&lang=ts"
export * from "./Paragraph.vue?vue&type=script&lang=ts"
import style0 from "./Paragraph.scss?vue&type=style&index=0&id=95dbd626&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dbd626",
  null
  
)

export default component.exports